type ShareCompany = {
	id: string,
	name: string,
};

type Price = {
	price: number,
	currency: string,
	date: string,
	currencyConverted: boolean,
};

export default class BaseShare {
	company: ShareCompany;

	securityName: string;

	latestPrice: Price | null;

	constructor(
		company: ShareCompany,
		securityName: string,
		latestPrice: Price | null,
	) {
		this.company = company
		this.securityName = securityName
		this.latestPrice = latestPrice
	}

	// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
	static deserialize(data: any): BaseShare {
		return new this(
			{
				id: data.company.id,
				name: data.company.name,
			},
			data.security_name,
			data.latest_price ? {
				price: data.latest_price.price,
				currency: data.latest_price.currency,
				date: data.latest_price.date,
				currencyConverted: data.latest_price.currency_converted,
			} : null,
		)
	}
}
